<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>

    <v-textarea
      :rules="rules"
      :name="schema.model"
      :id="generateId(schema.model)"
      v-bind="schema.attributesTextField"
      :disabled="schema.readonly"
      v-model="value"
      :ref="schema.model"
      @blur="onBlur"
      @click:clear="clear()"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @keydown="onKeydown($event, 'textarea')"
    >
      <template v-slot:label>
        {{ schema.attributesTextField.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-textarea>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  methods: {
    async onBlur() {
      this.changeEvents();
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    }
  }
};
</script>
